import React, { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./styles/components/ui/toasts.css";
import ReactDOM from "react-dom/client";
import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
} from "react-router-dom";
import "./styles/theme.css";
import "./styles/global.css";
import "./styles/components/ui/buttons.css";
import "./styles/components/pages/auth.css";
import "./styles/components/pages/landing.css";
import "./styles/components/layout/header.css";
import Root from "./pages/shared/root.jsx";
import ErrorPage from "./pages/shared/error-page.jsx";
import reportWebVitals from "./reportWebVitals.js";
import Question, {
  action as questionAction,
  loader as questionLoader,
} from "./components/question.jsx";
import ChangeQuestions from "./pages/instructor/manageQuestions.jsx";
import QuestionTable from "./components/tables/questionTable.jsx";
import HomePage from "./pages/shared/home.jsx";

import InstructorHome from "./pages/instructor/instructorPage.jsx";
import StudentHome from "./pages/student/studentPage.jsx";
import SubmissionTable from "./components/tables/submissionTable.jsx";
import QuestionEditor from "./components/forms/editQ.jsx";
import Posts from "./pages/student/studentList.jsx";
import TA from "./pages/instructor/taList.jsx";
import QEfficiency from "./components/qefficiency.jsx";
import PreviousQuestions from "./pages/student/prevQ.jsx";
import KnowledgeComponentsPage from "./pages/student/knowledgeComponents.jsx";
import StudentAuthentication from "./pages/auth/studentAuthentication.jsx";
import ConsentPage from "./pages/shared/consent-page.jsx";
import ChatApp from "./pages/chatbot/chatbotPage.jsx";
import { UserProvider } from "./contexts/UserContext"; // Import the UserProvider
import { TopicsProvider } from "./contexts/TopicsContext.jsx";
import { CourseProvider } from "./contexts/CourseContext";
import { AuthProvider } from "./contexts/AuthContext";
import { useCourse } from "./contexts/CourseContext";

if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  // etc.
}

// Fallback route component: if anything navigates to /join-course,
// redirect to dashboard and open the join modal.
function JoinCourseRedirect() {
  const { openJoinModal } = useCourse();
  useEffect(() => {
    try {
      openJoinModal();
    } catch (e) {
      console.warn("openJoinModal failed:", e);
    }
  }, [openJoinModal]);
  return <Navigate to="/dashboard" />;
}

const router = createBrowserRouter([
  {
    path: "/lab-buddy",
    element: <ChatApp />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/",
    element: <Root />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "/question/:questionId",
        element: <Question />,
        loader: questionLoader,
        action: questionAction,
      },
      {
        path: "/instructor/manageQuestions",
        element: <ChangeQuestions />,
        loader: () => {
          return null;
        },
        action: () => {
          return null;
        },
      },
      {
        path: "/instructor",
        element: <InstructorHome />,
        loader: () => {
          return null;
        },
        action: () => {
          return null;
        },
      },
      {
        path: "/editquestion/:id",
        element: <QuestionEditor />,
        loader: questionLoader,
        action: questionAction,
      },
      {
        path: "/dashboard",
        element: <StudentHome />,
        loader: () => {
          return null;
        },
        action: () => {
          return null;
        },
      },
      {
        path: "/previousQs",
        element: <PreviousQuestions />,
        loader: () => {
          return null;
        },
        action: () => {
          return null;
        },
      },
      {
        path: "/knowledge-components",
        element: <KnowledgeComponentsPage />,
        loader: () => {
          return null;
        },
        action: () => {
          return null;
        },
      },

      {
        path: "/questionTable",
        element: <QuestionTable />,
        loader: () => {
          return null;
        },
        action: () => {
          return null;
        },
      },
      {
        path: "/submissionTable",
        element: <SubmissionTable />,
        loader: () => {
          return null;
        },
        action: () => {
          return null;
        },
      },
      {
        path: "/",
        element: <HomePage />,
        loader: () => {
          return null;
        },
        action: () => {
          return null;
        },
      },
      {
        path: "/studentView",
        element: <Posts />,
        loader: () => {
          return null;
        },
        action: () => {
          return null;
        },
      },
      {
        path: "/qEfficiency/:id",
        element: <QEfficiency />,
        loader: () => {
          return null;
        },
        action: () => {
          return null;
        },
      },
      {
        path: "/TAView",
        element: <TA />,
        loader: () => {
          return null;
        },
        action: () => {
          return null;
        },
      },
      {
        path: "/studentAuth",
        element: <StudentAuthentication />,
        loader: () => {
          return null;
        },
        action: () => {
          return null;
        },
      },
      {
        path: "/join-course",
        element: <JoinCourseRedirect />,
        loader: () => {
          return null;
        },
        action: () => {
          return null;
        },
      },
      {
        path: "/consent",
        element: <ConsentPage />,
        loader: () => {
          return null;
        },
        action: () => {
          return null;
        },
      },
      // {
      //   path:"/topics",
      //   element: <TopicsPage/>,
      //   loader: ()=>{return null},
      //   action: ()=>{return null}
      // },
      // PLACE NEW PATHS HERE
      {

        path: "*",
        element: <Navigate to="/" />,
        loader: () => {
          return null;
        },
        action: () => {
          return null;
        },
      },
    ],

  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <UserProvider>
      <AuthProvider>
        <CourseProvider>
          <TopicsProvider>
            <RouterProvider router={router} />
            <ToastContainer position="top-right" autoClose={3000} />
          </TopicsProvider>
        </CourseProvider>
      </AuthProvider>
    </UserProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
